import { StyledPotentialSavingsToggler } from './PotentialSavingsToggler.style';
import { togglePotentialSavings } from '../../useFormState/form.state.actions';
import Checkbox from 'components/base/Checkbox';
import { CATEGORIES_KEYS } from '../../../../CategoriesWidget/useCategoriesWidget/useCategoriesWidget';

const PotentialSavingsToggler = ({ formState }) => {
  const {
    dispatch,
    [CATEGORIES_KEYS.POTENTIAL_SAVINGS]: potentialSavings = {}
  } = formState;

  const onChange = (e, isChecked) =>
    dispatch(togglePotentialSavings(isChecked));

  return (
    <StyledPotentialSavingsToggler>
      <Checkbox checked={potentialSavings.enabled} onChange={onChange} />
      Include <b>Inefficiency Pool</b> - this is a calculated category, showing
      the percentage of work that can be optimized from the overall engineering
      org work
    </StyledPotentialSavingsToggler>
  );
};

export default PotentialSavingsToggler;
